import React from 'react'
import { Router, Route, browserHistory } from 'react-router'
import axios from 'axios'
import WebFont from 'webfontloader'
import ReactDOM from 'react-dom'
import './static/scss/App.scss'
import config from 'Config/config';

const apiURI = config.apiURI;

/* Layouts */
import AppLayout from './components/AppLayout'

/* Pages */
import Congrats from './components/Congrats'
import DAZNCongrats from './components/DAZNCongrats'
import DAZNEmail from './components/DAZNEmail'
import Email from './components/Email'
import Invalid from './components/Invalid'
import LandingPage from './components/LandingPage'
import Redeem from './components/Redeem'
import Spinner from './components/Spinner'

//localStorage.setItem('stadiumRedemptionToken', '71ce8c8f-8cc1-40de-b8e7-f1023d8ed3ef')
//localStorage.setItem('stadiumRedemptionToken', '1a4fa812-ba76-414c-9150-61f7f3610e73') // winner that goes with bx test 5 in cowboy christmas venue
//localStorage.setItem('stadiumRedemptionToken', '993b3e7b-7e4c-4939-8f35-0e110a107710') // non-winner that goes with bx test 5 in cowboy christmas venue

let loadFonts = true
const DAZN_VENUE = 30

const routeToNextEntry = (responseRoute, isDazn) => {
  switch (responseRoute) {
    case '/expired':
      return {
        pathname: 'invalid',
        state: { next: null }
      }
    case '/email':
      if (isDazn) {
        return {
          pathname: 'dazn1',
          state: { next: '/thanks' }
        }
      } else {
        if (localStorage.landingPages !== undefined && localStorage.landingPages !== 'undefined') {
          return {
            pathname: 'email',
            state: { next: '/landingpage/0' }
          }
        } else {
          return {
            pathname: 'email',
            state: { next: '/redeem' }
          }
        }

      }
    case '/landing':
      return {
        pathname: '/landingpage/0',
        state: { next: '/redeem' }
      }
    case '/redeem':
      return {
        pathname: 'redeem',
        state: { next: '/thanks' }
      }
    case '/thanks':
      if (isDazn) {
        return {
          pathname: 'dazn2',
          state: { next: null }
        }
      } else {
        return {
          pathname: 'thanks',
          state: { next: null }
        }
      }
  }
}

function requireAuth (nextState, replace, callback) {
  ReactDOM.render(<Spinner/>, document.getElementById('spinner'))

  if (nextState.location.query.t) {
    localStorage.stadiumRedemptionToken = nextState.location.query.t
  }
  axios.get(apiURI + localStorage.stadiumRedemptionToken)
    .then(response => {
      ReactDOM.unmountComponentAtNode(document.getElementById('spinner'))
      const isDazn = response.data.venueId === DAZN_VENUE
      localStorage.stadiumRedemptionVenue = response.data.venueId
      localStorage.nonWinner = !!!response.data.isWinner
      localStorage.verificationPIN = response.data.verificationPIN
      sessionStorage.pinSent = response.data.pinSent
      localStorage.logo = response.data.logo
      localStorage.fillColor = response.data.fillColor
      localStorage.borderColor = response.data.borderColor
      localStorage.buttonFontColor = response.data.buttonFontColor
      localStorage.fontColor = response.data.fontColor
      localStorage.redemptionColor = response.data.redemptionColor
      localStorage.redemptionHeader = response.data.redemptionHeader
      localStorage.secondRedeemedLogo = response.data.secondRedeemedLogo
      localStorage.promoCode = response.data.promoCode
      localStorage.landingPages = response.data.landingPages
      localStorage.emailHeaderText = response.data.emailHeaderText
      localStorage.emailPrePromptText = response.data.emailPrePromptText
      localStorage.emailPostPromptText = response.data.emailPostPromptText
      localStorage.redemptionPage = response.data.redemptionPage
      localStorage.maxAgeCopy = response.data.maxAgeCopy
      localStorage.daznLocation = response.data.daznLocation
      localStorage.daznOffer = response.data.daznOffer
      localStorage.daznDirections = response.data.daznDirections
      localStorage.daznHeader = response.data.daznHeader
      localStorage.daznEmail = response.data.daznEmail
      localStorage.termsAndConditions = !!(response.data.termsAndConditionsCopy || response.data.termsAndConditionsLink)
      localStorage.termsAndConditionsCopy = response.data.termsAndConditionsCopy
      localStorage.termsAndConditionsLink = response.data.termsAndConditionsLink
      localStorage.downloadLinks = !!(response.data.androidDownloadLink || response.data.iosDownloadLink)
      localStorage.androidDownloadLink = response.data.androidDownloadLink
      localStorage.iosDownloadLink = response.data.iosDownloadLink
      localStorage.thankYouImageAndLink = !!(response.data.thankYouImage && response.data.thankYouImageLink)
      localStorage.thankYouImage = response.data.thankYouImage
      localStorage.thankYouImageLink = response.data.thankYouImageLink
      localStorage.barcode = response.data.barcode
      localStorage.qrCode = response.data.qrCode

      if (response.data.fontTopPadding !== undefined && response.data.fontTopPadding !== null && response.data.fontTopPadding !== '') {
        localStorage.fontTopPadding = response.data.fontTopPadding
      } else {
        localStorage.fontTopPadding = '0'
      }
      if (response.data.fontBottomPadding !== undefined && response.data.fontBottomPadding !== null && response.data.fontBottomPadding !== '') {
        localStorage.fontBottomPadding = response.data.fontBottomPadding
      } else {
        localStorage.fontBottomPadding = '0'
      }
      if (response.data.fontLeftPadding !== undefined && response.data.fontLeftPadding !== null && response.data.fontLeftPadding !== '') {
        localStorage.fontLeftPadding = response.data.fontLeftPadding
      } else {
        localStorage.fontLeftPadding = '0'
      }
      if (response.data.fontRightPadding !== undefined && response.data.fontRightPadding !== null && response.data.fontRightPadding !== '') {
        localStorage.fontRightPadding = response.data.fontRightPadding
      } else {
        localStorage.fontRightPadding = '0'
      }

      if (loadFonts) {
        let fontFamilyList
        if (response.data.fontFamily !== undefined && response.data.fontFamily !== null && response.data.fontFamily !== '') {
          localStorage.fontFamily = response.data.fontFamily
          fontFamilyList = response.data.fontFamily + ' ,League Gothic, sans-serif'
        } else {
          localStorage.fontFamily = 'League Gothic'
          fontFamilyList = 'League Gothic, sans-serif'
        }
        if (response.data.fontWeight !== undefined && response.data.fontFamily !== null && response.data.fontFamily !== '') {
          localStorage.fontWeight = response.data.fontWeight
        } else {
          localStorage.fontWeight = '400'
        }
        if (response.data.fontSize !== undefined && response.data.fontSize !== null && response.data.fontSize !== '') {
          localStorage.fontSize = response.data.fontSize
        } else {
          localStorage.fontSize = '16'
        }

        WebFont.load({
          google: {
            families: [localStorage.fontFamily + ':' + localStorage.fontWeight]
          }
        })
        document.body.style.fontFamily = fontFamilyList
        document.body.style.fontSize = localStorage.fontSize + 'px'
        loadFonts = false
      }

      const route = routeToNextEntry(response.data.route, isDazn)
      console.log(route)

      if (nextState.location.pathname === '/'
        || nextState.location.pathname === '/email' || nextState.location.pathname === '/dazn1') {
        replace({
          pathname: route.pathname,
          state: route.state
        })
      }

      callback()
    })
    .catch(() => {
      ReactDOM.unmountComponentAtNode(document.getElementById('spinner'))
      replace({
        pathname: 'invalid',
        state: { nextPathname: nextState.location.pathname }
      })
    })
}

let redeemCalled = false

function redeem () {
  if (redeemCalled) {
    return
  }
  axios.post(apiURI + localStorage.stadiumRedemptionToken, { isWinner: !localStorage.nonWinner })
    .then(response => { redeemCalled = true })
}

function saveEmail () {
  axios.put(apiURI + localStorage.stadiumRedemptionToken, { email: localStorage.email })
    .then(() => {})
}

export default (
  <Router history={browserHistory}>

    <Route path="/" component={AppLayout} onEnter={requireAuth}>
      <Route path="invalid" component={Invalid}/>
      <Route path="email" component={Email} onLeave={saveEmail} />
      <Route path="dazn1" component={DAZNEmail} onLeave={saveEmail}/>
      <Route path="landingpage/:index" component={LandingPage}/>
      <Route path="redeem" component={Redeem} onLeave={redeem}/>
      <Route path="thanks" component={Congrats}/>
      <Route path="dazn2" component={DAZNCongrats}/>
    </Route>
  </Router>
)



// WEBPACK FOOTER //
// ./src/router.js